import React from "react";

const features = [
  { title: "Uncompromising Security", icon: "🔐" },
  { title: "Built-In Regulatory Compliance", icon: "⚖️" },
  { title: "Web3 API Integration", icon: "🔗" },
];

const AssetAgnosticism = () => {
  return (
    <section className="section px-6 py-24 max-w-7xl mx-auto">
      <div
        className="rounded-3xl overflow-hidden relative"
        style={{
          background: "linear-gradient(135deg, #0d1120 0%, #0a1a14 100%)",
          border: "1px solid rgba(82,198,168,0.12)",
          boxShadow: "0 0 80px rgba(82,198,168,0.06)",
        }}
      >
        {/* Grid bg overlay */}
        <div className="absolute inset-0 grid-bg opacity-50" />

        {/* Radial glow */}
        <div
          className="absolute"
          style={{
            top: "-100px", left: "50%", transform: "translateX(-50%)",
            width: "600px", height: "400px",
            background: "radial-gradient(ellipse, rgba(82,198,168,0.1) 0%, transparent 70%)",
          }}
        />

        <div className="relative z-10 px-12 py-20 flex flex-col items-center text-center">
          <div className="badge mb-6">
            <span className="badge-dot" />
            Protocol Layer
          </div>

          <h2
            className="font-syne font-bold mb-4"
            style={{ fontSize: "clamp(36px, 5vw, 64px)", color: "#e8eaf0", letterSpacing: "-0.02em" }}
          >
            Asset <span className="grad-text">Agnosticism</span>
          </h2>

          <p
            className="max-w-xl mb-16 text-base"
            style={{ color: "var(--c-muted)", fontFamily: "'DM Sans', sans-serif", lineHeight: 1.7 }}
          >
            Enabling Payment Gateways to Accept Cahex Payments with our Network's Technology — Universal Liquidity Protocol.
          </p>

          {/* Feature cards */}
          <div className="flex flex-col sm:flex-row gap-5 w-full max-w-3xl">
            {features.map(({ title, icon }) => (
              <div
                key={title}
                className="flex-1 glow-box rounded-2xl p-6 text-center cursor-default transition-all duration-300 corner-tl corner-br"
                style={{ background: "rgba(255,255,255,0.03)" }}
              >
                <div className="text-3xl mb-3">{icon}</div>
                <div
                  className="font-syne font-semibold text-sm"
                  style={{ color: "#e8eaf0", lineHeight: 1.4 }}
                >
                  {title}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AssetAgnosticism;
